import React, { useState } from "react";

import { serializeError } from "serialize-error";

import { PrimaryButton } from "@shared/buttons";
import { TextInput } from "@shared/text-input";

type ParseInput =
  | {
      type: "error";
      msg: string;
    }
  | {
      type: "parsed";
      parsedInput: string;
    };

interface UpdateLoginCustomerIdProps {
  updateConnection: any;
  loginCustomerId: string;
  parseInput: (input: string) => ParseInput;
}

enum RequestStatus {
  NO_REQUEST,
  LOADING,
  SUCCESSFUL,
  HAS_ERROR,
}

export default function UpdateLoginCustomerId({
  loginCustomerId,
  updateConnection,
  parseInput,
}: UpdateLoginCustomerIdProps) {
  const [newLoginId, setNewLoginId] = useState(loginCustomerId);
  const [status, setStatus] = useState<RequestStatus>(RequestStatus.NO_REQUEST);
  const [error, setError] = useState<string>("");

  const onSave = async () => {
    const parsedInput = parseInput(newLoginId);
    if (parsedInput.type === "error") {
      setStatus(RequestStatus.HAS_ERROR);
      setError(parsedInput.msg);
      return;
    }

    setStatus(RequestStatus.LOADING);
    const result = await updateConnection({
      login_customer_id: parsedInput.parsedInput,
    });

    if (result.errors) {
      setStatus(RequestStatus.HAS_ERROR);
      setError(JSON.stringify(serializeError(result.error)));
    } else {
      setStatus(RequestStatus.SUCCESSFUL);
    }
  };

  const renderErrorStatus = () => {
    if (status === RequestStatus.HAS_ERROR) {
      return (
        <div className="alert alert-danger mb-3" role="alert">
          An error occurred: &ldquo;{error}&rdquo;
        </div>
      );
    }
    return null;
  };

  const renderButtonContent = () => {
    return status === RequestStatus.LOADING ? (
      <span
        className="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      />
    ) : (
      "SAVE"
    );
  };

  const renderUpdateLoginIdButton = () => (
    <div className="flex space-x-2">
      <TextInput
        className="flex-grow"
        placeholder="Login Account ID"
        onChange={({ target }) => setNewLoginId(target.value)}
        value={newLoginId}
        disabled={status === RequestStatus.LOADING}
      />
      <PrimaryButton
        onClick={onSave}
        disabled={status === RequestStatus.LOADING}
      >
        {renderButtonContent()}
      </PrimaryButton>
    </div>
  );

  return (
    <>
      <label>Update your login customer id (parent MCC account)</label>
      {renderErrorStatus()}
      {renderUpdateLoginIdButton()}
    </>
  );
}
